var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5469 8.14815H2.85714C2.38376 8.14815 2 7.75018 2 7.25926C2 6.76834 2.38376 6.37037 2.85714 6.37037H13.5469C13.92 5.00237 15.1328 4 16.5714 4C18.01 4 19.2229 5.00237 19.596 6.37037H21.1429C21.6162 6.37037 22 6.76834 22 7.25926C22 7.75018 21.6162 8.14815 21.1429 8.14815H19.596C19.2229 9.51615 18.01 10.5185 16.5714 10.5185C15.1328 10.5185 13.92 9.51615 13.5469 8.14815ZM15.1429 7.25926C15.1429 6.44106 15.7825 5.77778 16.5714 5.77778C17.3604 5.77778 18 6.44106 18 7.25926C18 8.07746 17.3604 8.74074 16.5714 8.74074C15.7825 8.74074 15.1429 8.07746 15.1429 7.25926Z",
    fill: "#0088CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4531 17.6296H21.1429C21.6162 17.6296 22 17.2317 22 16.7407C22 16.2498 21.6162 15.8519 21.1429 15.8519H10.4531C10.08 14.4838 8.86717 13.4815 7.42857 13.4815C5.98997 13.4815 4.77712 14.4838 4.40402 15.8519H2.85714C2.38376 15.8519 2 16.2498 2 16.7407C2 17.2317 2.38376 17.6296 2.85714 17.6296H4.40402C4.77712 18.9976 5.98997 20 7.42857 20C8.86717 20 10.08 18.9976 10.4531 17.6296ZM6 16.7407C6 15.9225 6.63959 15.2593 7.42857 15.2593C8.21755 15.2593 8.85714 15.9225 8.85714 16.7407C8.85714 17.5589 8.21755 18.2222 7.42857 18.2222C6.63959 18.2222 6 17.5589 6 16.7407Z",
    fill: "#0088CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.1d1102867bbffef6a83198992e315b46.svg";
export { ForwardRef as ReactComponent };